// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shrink{font-size:1rem;line-height:120%;font-weight:700}@media screen and (max-width:450px){.shrink{font-size:.3rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
